<template>
  <div
    class="c-container"
    :class="{ '-is-side': isSide }"
  >
    <div
      class="c-dataGroup"
      v-if="!isBusiness && !(isPC && isBlog)"
    >
      <div class="c-dataTitle">
        <span class="c-dataTitle_text">実績</span>
      </div>
      <ul class="c-dataValue_list">
        <li class="c-dataValue_item">
          <span class="c-dataValue_name">販売実績</span>
          <span class="c-dataValue_value">{{ achievementCountDisplay }}</span>
        </li>
        <li class="c-dataValue_item">
          <span class="c-dataValue_name">評価</span>
          <span class="c-dataValue_value">
            <coconala-icon
              name="star"
              color="yellow"
            />
            {{ ratingAvgDisplay }}
          </span>
        </li>
        <li class="c-dataValue_item">
          <span class="c-dataValue_name">フォロワー</span>
          <span class="c-dataValue_value">{{ followerCountDisplay }}</span>
        </li>
      </ul>
    </div>
    <div
      class="c-dataGroup"
      v-if="!isBusiness && !(isPC && isBlog)"
    >
      <div class="c-dataTitle -authentication">
        <span class="c-dataTitle_text">認証状況</span>
      </div>
      <ul class="c-dataValue_list -authentication">
        <li class="c-dataValue_item -authentication">
          <span
            class="c-dataValue_name"
            v-if="isEditable"
          >
            <a :href="$coconala.url('/mypage/user_identification')">本人確認</a>
          </span>
          <span
            class="c-dataValue_name"
            v-else
          >
            本人確認
          </span>
          <span
            class="c-dataValue_value"
            v-if="isIdentification"
          >
            <b-tooltip
              label="本人確認：済"
              type="is-black"
              size="is-small"
              position="is-bottom"
              :active="$ua.isFromPc()"
            >
              <coconala-icon
                name="user-square"
                size="12px"
              />
            </b-tooltip>
            <coconala-icon
              name="check"
              size="12px"
            />
          </span>
          <span
            class="c-dataValue_value"
            v-else
          >
            <b-tooltip
              label="本人確認：未"
              type="is-black"
              size="is-small"
              position="is-bottom"
              :active="$ua.isFromPc()"
            >
              <coconala-icon
                name="user-square"
                size="12px"
              />
            </b-tooltip>
            <coconala-icon
              name="minus"
              size="12px"
            />
          </span>
        </li>
        <li class="c-dataValue_item -authentication">
          <span
            class="c-dataValue_name"
            v-if="isEditable"
          >
            <a :href="$coconala.url('/mypage/nda')">機密保持契約(NDA)</a>
          </span>
          <span
            class="c-dataValue_name"
            v-else
          >
            機密保持契約(NDA)
          </span>
          <span
            class="c-dataValue_value"
            v-if="isNdaConclusion"
          >
            <b-tooltip
              label="機密保持契約：済"
              type="is-black"
              size="is-small"
              position="is-bottom"
              :active="$ua.isFromPc()"
            >
              <coconala-icon
                name="lock_square"
                size="12px"
              />
            </b-tooltip>
            <coconala-icon
              name="check"
              size="12px"
            />
          </span>
          <span
            class="c-dataValue_value"
            v-else
          >
            <b-tooltip
              label="機密保持契約：未"
              type="is-black"
              size="is-small"
              position="is-bottom"
              :active="$ua.isFromPc()"
            >
              <coconala-icon
                name="lock_square"
                size="12px"
              />
            </b-tooltip>
            <coconala-icon
              name="minus"
              size="12px"
            />
          </span>
        </li>
      </ul>
    </div>
    <div
      class="c-dataSchedule"
      :class="{ 'c-dataSchedule-edit': isEditable }"
      v-if="(schedule.length !== 0 || isEditable) && !(isPC && isSide)"
    >
      <div class="c-dataTitle">
        <span class="c-dataTitle_text">スケジュール</span>
        <a
          class="c-scheduleEdit"
          :href="$coconala.url('/mypage/user/info')"
          v-if="isEditable"
        >
          <coconala-icon
            name="pencil-square-o"
            size="12px"
          />
          スケジュール編集画面へ
        </a>
      </div>
      <p
        class="c-dataValue_block nl2br"
        :class="{ 'c-dataValue_block-empty': schedule.length === 0 }"
        v-text="displaySchedule"
      ></p>
      <div
        class="c-dataValue_readMoreSchedule"
        v-if="needReadMore && !scheduleExpanded"
      >
        <a @click="scheduleExpanded = true">
          <coconala-icon
            name="chevron-down"
            size="11px"
          />
          <span>もっと見る</span>
        </a>
      </div>
    </div>
    <div v-if="isBlog && isPC && !isEditable && !isBusiness">
      <blog-sub-area />
    </div>
  </div>
</template>
<script>
import CoconalaIcon from '~/components/atoms/CoconalaIcon'
import BlogSubArea from '~/components/organisms/BlogSubArea'
import util from '~/assets/javascripts/util'
import { mapGetters } from 'vuex'

const SCHEDULE_EMPTY_MESSAGE = 'あなたの詳細なスケジュールを登録できます'

export default {
  name: 'UserDataCard',
  components: {
    CoconalaIcon,
    BlogSubArea
  },
  props: {
    isSide: {
      type: Boolean
    },
    achievementCount: {
      type: Number
    },
    ratingAvg: {
      type: Number
    },
    followerCount: {
      type: Number
    },
    isIdentification: {
      type: Boolean,
      default: false
    },
    isNdaConclusion: {
      type: Boolean,
      default: false
    },
    schedule: {
      type: String
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isBlog: {
      type: Boolean,
      default: false
    },
    isBusiness: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scheduleExpanded: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    scheduleNotExpansionLimitCount() {
      return this.isPC ? 165 : 23 // スケジュールの字数がこれを超えたら省略する
    },
    scheduleNotExpansionLimitRows() {
      return this.isPC ? 3 : 1 // スケジュールの行数がこれを超えたら省略する
    },
    achievementCountDisplay() {
      return util.numberWithDelimiter(this.achievementCount)
    },
    ratingAvgDisplay() {
      if (!this.ratingAvg) return '-'
      return this.ratingAvg.toFixed(1)
    },
    followerCountDisplay() {
      return util.numberWithDelimiter(this.followerCount)
    },
    needReadMore() {
      if (this.schedule.length === 0 || this.isEditable) {
        return false
      }

      if (this.schedule.length > this.scheduleNotExpansionLimitCount) {
        return true
      }

      if (this.schedule.split('\n').length > this.scheduleNotExpansionLimitRows) {
        return true
      }

      return false
    },
    displaySchedule() {
      if (this.schedule.length === 0) {
        return SCHEDULE_EMPTY_MESSAGE
      }

      if (!this.needReadMore || this.scheduleExpanded) {
        return this.schedule
      }

      const slicedSchedule = this.schedule
        .split('\n')
        .slice(0, this.scheduleNotExpansionLimitRows)
        .join('\n')
      return this.$util.truncate(slicedSchedule, this.scheduleNotExpansionLimitCount)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-container {
  font-size: 12px;
}

a {
  @include link-effect;
}

.c-dataGroup {
  display: flex;

  align-items: baseline;
}

.c-dataTitle {
  margin: 8px 8px 0 0;
  min-width: 6em;
  white-space: nowrap;
  &_text {
    padding: 2px 4px;
    border-radius: 3px;
    background-color: $color-gray-50;
    font-size: 10px;
  }
  &_separate {
    display: none;
  }
}

.c-dataValue {
  &_list {
    display: flex;

    flex-wrap: wrap;
  }
  &_block {
    margin: 4px 0 0;
    width: calc(100% - 200px);

    &-empty {
      color: $color-gray-600;
    }
  }
  &_item {
    margin-right: 8px;
    white-space: nowrap;
    &.-authentication {
      i {
        color: $color-gray-700;
      }
    }
  }
  &_name {
  }
  &_value {
    vertical-align: -1px;
    font-weight: bold;
    font-size: 15px;
    i {
      vertical-align: -1px;
      &.-check {
        color: $color-deep-green-500;
      }
      &.-minus {
        color: $color-gray-500;
      }
    }
  }
  &_readMoreSchedule {
    margin-top: 4px;
    width: calc(100% - 200px);
    text-align: center;
    font-weight: bold;
    font-size: 12px;
    a {
      color: $color-gray-600;
    }
  }
}

.c-scheduleEdit {
  float: right;
  margin-right: 192px;
}

@media (max-width: $breakpoint-l) {
  .c-container {
  }
}

@media (max-width: $breakpoint-m) {
  .c-container {
    position: static;
  }
  .c-dataValue {
    &_block {
      width: 100%;
    }
    &_readMoreSchedule {
      margin: 0;
      a {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      .-chevron-down {
        position: absolute;
        top: calc(50% - 5px);
        right: 16px;
      }
      span {
        display: none;
      }
    }
  }
  .c-dataSchedule {
    position: relative;
    margin: 8px -10px -5px;
    padding: 0 10px 5px;
    border-top: 1px solid $color-gray-200;

    &-edit {
      margin-bottom: 7px;
      border-bottom: 1px solid $color-gray-200;
    }
  }
  .c-scheduleEdit {
    margin-right: 0;
  }
}

@media (max-width: $breakpoint-s) {
  .c-dataTitle {
    min-width: 0;
  }
}

// side
.c-container.-is-side {
  @media (min-width: $breakpoint-m + 1) {
    position: static;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid $color-border-base;
    .c-dataGroup {
      display: block;
      & + .c-dataGroup {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid $color-border-light;
      }
    }
    .c-dataTitle {
      margin-bottom: 0.5em;
      &_text {
        padding: 0;
        background: none;
        font-weight: bold;
        font-size: 14px;
      }
    }
    .c-dataValue {
      &_list {
        display: block;
      }
      &_item {
        display: flex;
        margin-left: 0;
      }
      &_name {
      }
      &_value {
        margin-left: auto;
        i {
          margin-right: 0.1em;
        }
      }
    }
  }
}
</style>
